export default __webpack_public_path__ + "static/media/iconomail.4426a3f0.jpg";